import {
  ENDPOINT_ORDERS,
  ENDPOINT_ROOT,
  SYNC_KEY_PARAM,
} from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const postOrder = (data) => {
  const params = {
    ...data,
  };
  delete params.sync;

  const sync = data.sync || 0;

  return axiosAuth
    .post(
      `${ENDPOINT_ROOT}/${ENDPOINT_ORDERS}?${SYNC_KEY_PARAM}=${sync}`,
      params,
    )
    .then((res) => res.data);
};

export default postOrder;
